module.exports = __webpack_public_path__ + "img/robot.png?98bba3566e36b3966dc29d5cd7ba0106";